(function () {
  /* Albeux wishlist heart.
     Fix: the old script rewrote the "Save" label inside a MutationObserver that watched the whole page.
     Rewriting the label is itself a page change, so the observer fired again, rewrote the label again,
     and so on forever. That endless loop froze every product page (very slow, hanging, swiping dead).
     Now: nothing is written unless the value really changed, and the observer only reacts when a new
     wishlist button is added to the page.
     Selection page ("Your Selection", /pages/wishlist): lists every saved piece, newest first, in a steady order, with a count. */
  var KEY = 'albeux_wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
  }
  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function sync() {
    var list = get();
    document.querySelectorAll('[data-albeux-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      setAttr(b, 'aria-pressed', on ? 'true' : 'false');
      if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on);
      var label = b.querySelector('.albeux-wish__label');
      var text = on ? 'Saved' : 'Save';
      if (label && label.textContent !== text) label.textContent = text;
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function renderPage() {
    var root = document.querySelector('[data-albeux-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('.albeux-wishlist__grid');
    var empty = root.querySelector('.albeux-wishlist__empty');
    var countEl = root.querySelector('[data-albeux-wishlist-count]');
    var list = get().slice().reverse();
    var token = (root.__albeuxToken = (root.__albeuxToken || 0) + 1);
    empty.hidden = list.length > 0;
    if (!list.length) {
      grid.innerHTML = '';
      if (countEl) countEl.textContent = '';
      return;
    }
    Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return { handle: handle, p: p }; }, function () { return { handle: handle, p: null }; });
    })).then(function (rows) {
      if (token !== root.__albeuxToken) return;
      grid.innerHTML = '';
      var shown = 0;
      rows.forEach(function (row) {
        var p = row.p;
        if (!p) return;
        shown++;
        var item = document.createElement('div');
        item.className = 'albeux-wishlist__item';
        var link = document.createElement('a');
        link.href = p.url;
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          img.alt = p.title;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        var name = document.createElement('span');
        name.className = 'albeux-wishlist__name';
        name.textContent = p.title;
        var price = document.createElement('span');
        price.className = 'albeux-wishlist__price';
        price.textContent = money(p.price);
        link.appendChild(name);
        link.appendChild(price);
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'albeux-wishlist__remove';
        rm.setAttribute('data-albeux-remove', row.handle);
        rm.textContent = 'Remove';
        item.appendChild(link);
        item.appendChild(rm);
        grid.appendChild(item);
      });
      if (countEl) countEl.textContent = shown ? (shown === 1 ? '1 piece' : shown + ' pieces') : '';
      empty.hidden = shown > 0;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-albeux-wish]');
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-handle');
      var list = get();
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      save(list);
      return;
    }
    var r = e.target.closest('[data-albeux-remove]');
    if (r) {
      var h2 = r.getAttribute('data-albeux-remove');
      save(get().filter(function (x) { return x !== h2; }));
      renderPage();
    }
  });
  function init() { sync(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Pick up wishlist buttons that arrive later (section re-renders, variant changes).
     Only added ELEMENTS that contain a wishlist button count, so our own label update can never retrigger it. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }
  function hasWish(node) {
    return node.nodeType === 1 && (node.hasAttribute('data-albeux-wish') || !!node.querySelector('[data-albeux-wish]'));
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasWish(added[j])) { schedule(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
